// [init]
import _ from 'lodash'

export default {


	namespaced: true,
	
	state: {
		
		
		// Determines if the user is signed-in or not.
		
		isSignedIn : false,
		isFBlogged : false,
		
		
		// The JWT received from the server post sign-in.
		
		jwt        : '', 
		
		
		// The user’s ID.
		
		id         : '', 
		
		
		// Other user details.
		
		fullname   : '',
		email      : '',
		type       : '',
		creditCardLast4 : '',
		creditCardExpiryMonth : '',
		creditCardExpiryYear : '',
		creditsLeft : 0,



	},
	
	mutations: {
		
		
		// Manipulate user’s data. (STABLE)

		storeUserData ( state, params ) {
			
			
			// Store all user properties.
			
			for ( var key in params ) state[key] = params[key];
			state.jwt = params.jwt;
			
			
			// Set user as signed-in.
			
			state.isSignedIn = true;
			
			
			// Instruct Axios to add the `Authorization` header for all requests from this point.
			
			global.axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.jwt;
			

			// Store JWT in localStorage/sessionStorage.
			
			if ( params.staySignedIn ) localStorage.setItem ( 'params', JSON.stringify ( state ) );
			else sessionStorage.setItem ( 'params', JSON.stringify ( state ) );
			

		},
	
		removeUserData ( state ) {
			
			
			// Remove all user properties.
			
			for ( var key in state ) state[key] = '';
			
			
			// Set user as signed-out.
			
			state.isSignedIn = false;
			
			
			// Instruct Axios to NO LONGER add the `Authorization` header for all requests from this point.
			
			delete global.axios.defaults.headers.common['Authorization'];
			
			
			// Remove localStorage/sessionStorage property.
			
			try {
				
				sessionStorage.removeItem ( 'params' );
				localStorage.removeItem ( 'params' );
				
			}
			catch ( e ) {}


		},
		updateCard(state,params){
			 console.log(params);
         for(const key in params)
         {
         	state[key] = params[key];
         }



			if ( params.staySignedIn ) localStorage.setItem ( 'params', JSON.stringify ( state ) );
			else sessionStorage.setItem ( 'params', JSON.stringify ( state ) );


		},

		updateUserInfo( state, params ) {

			for ( const key in params ) {
				if (key === 'creditsLeft') {
					state[key] = state[key] + params[key];
				} else {
					state[key] = params[key];
				};
                // state[key] = params[key];
            };

			// Store JWT in localStorage/sessionStorage.
			
			if ( params.staySignedIn ) localStorage.setItem ( 'params', JSON.stringify ( state ) );
			else sessionStorage.setItem ( 'params', JSON.stringify ( state ) );

		},

		updateUserCreditInfo( state, params ) {

			for ( const key in params ) {
				state[key] = params[key];
            };

			// Store JWT in localStorage/sessionStorage.
			
			if ( params.staySignedIn ) localStorage.setItem ( 'params', JSON.stringify ( state ) );
			else sessionStorage.setItem ( 'params', JSON.stringify ( state ) );

		},

		updateName(state, params) {
			state.firstname = params.firstname
			state.lastname = params.lastname
            localStorage.setItem ( 'params', JSON.stringify ( state ) )
            sessionStorage.setItem ( 'params', JSON.stringify ( state ) )
		}
		
	
	}, // END: mutations
	
	actions: {
		
		
		// Authentication actions. (STABLE)

		signin ( { commit, state }, params ) {


			// Validate and send the request.
			
			return new Promise ( ( resolve, reject ) => {
				
				
				// Validate.
				
				params.identity = params.identity.trim ();
				params.password = params.password.trim ();
				
				if ( ! params.identity || ! params.password ) reject ( '[error] Missing `identity` and/or `password` parameter.' );
				
				
				// Make the request.
				
				global.axios.request ( {
						
					method         : 'post',
					url            : process.env.SIGNIN_API,
					validateStatus : function ( status ) { return status == 200; },
					data           : {
						
						identity : params.identity,
						password : params.password
						
					}
					
				} )
				
				
				// Success.
				
				.then ( ( response ) =>  {

					
					// Controls.
					
					var userData = response.data;
					
					userData.staySignedIn = params.staySignedIn;
					userData.type = 'admin';
					
					
					// Store in the state.
					
					commit ( 'storeUserData', userData );
					
					// Resolve.
					
					resolve ( response );


				} )
				
				
				// Error.
				
				.catch ( ( error ) => reject ( error ) );
				
				
			} );


		},

		verifyCustomer ( { commit, state }, data ) {

			return new Promise ((resolve, reject) => {

				const postData = {
					mobile: data.mobile,
					otp: data.otp
				};

				global.axios.request({
					method: 'post',
					url: '/customers/verify',
					data: postData,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					let userData = response.data;
					userData.staySignedIn = data.staySignedIn;
					userData.type = 'customer';
					state.isFBlogged = false;
					commit ( 'storeUserData', userData );

					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},


		loginfaebook( { commit, state }, data ) {
			return new Promise ( (resolve, reject ) => {
				const postData = data;
				global.axios.request({
					method: 'post',
					url: '/customers/fb-login',
					data: postData,
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
						if(response.data.status==200){
						resolve( response );
					} else {
						let userData 			= response.data;
						userData.staySignedIn 	= data.staySignedIn;
						userData.type = 'customer';
						state.isFBlogged = true;
						commit('storeUserData', userData );
						resolve( response );
					}
				})
				.catch(error => reject( error ));

			});

		},

		verifyCleaner ( { commit, state }, data ) {

			return new Promise ((resolve, reject) => {

				const postData = {
					mobile: data.mobile,
					otp: data.otp
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/verify',
					data: postData,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					let userData = response.data;
					userData.staySignedIn = data.staySignedIn;
					userData.type = 'cleaner';

					commit ( 'storeUserData', userData );

					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},
				
		signout ( { commit, state }, params ) {


			// Sign the user out completely.
			
			commit ( 'auth/removeUserData', false, { root: true } );	


		},
		
		authenticate ( { commit } ) {
			
			
			// Retrieve stored user data.
			
			var localRecord = sessionStorage.getItem ( 'params' ) ? sessionStorage.getItem ( 'params' ) : localStorage.getItem ( 'params' );
			

			// User does not have a session.
			
			if ( ! localRecord ) return commit ( 'removeUserData' );
			
			
			// Record is a proper JSON string.
			
			try {
				
				commit ( 'storeUserData', JSON.parse ( localRecord ) );
				
			}
			catch ( error ) {
				
				commit ( 'removeUserData' );
				
			}


		},
		
		fetch ( { commit, state }, params ) {
			
			
			return new Promise ( ( resolve, reject ) => {
				
				global.axios.request ( {
						
					method         : 'get',
					url            : process.env.USERS_API + '/' + state.id,
					validateStatus : function ( status ) { return status == 200; }
					
				} )
				.then ( ( response ) => resolve ( response.data ) )
				.catch ( ( error ) => reject ( error ) );
				
			} );
			
			
		},		

		update ( { commit, state }, params ) {
			
			return new Promise ( ( resolve, reject ) => {
				
				global.axios.request ( {
						
					method         : 'post',
					url            : process.env.USERS_API + '/' + state.id + '/update',
					validateStatus : function ( status ) { return status == 200; },
					data           : params
					
				} )
				.then ( ( response ) =>  {
					
					
					// If we are updating the current user’s details, then update the state as well.
					
					commit ( 'storeUserData', params );
					
					
					// All’s good!
					
					resolve ( response );
					
					
				} )
				.catch ( ( error ) => reject ( error ) );
				
			} );
			
		},

		updateUserInfo( { commit, state }, data ) {

			commit( 'updateUserInfo', data );

		},

		updateUserCreditInfo( { commit, state }, data ) {

			commit( 'updateUserCreditInfo', data );

		},

        updateName( { commit, state }, data ) {

            commit( 'updateName', data );

        },
		updateCard({commit,state},data)
		{

			commit('updateCard',data);
		},

        fetchCustomer({commit, state}, data) {

            return new Promise((resolve, reject) => {
                global.axios.request({

                    method: 'get',
                    url: '/customers/' + state.id,
                    validateStatus: function (status) {
                        return status == 200;
                    }

                })
                    .then((response) => {
                        let userData = response.data;
                        // userData.staySignedIn = data.staySignedIn;
                        userData.type = 'customer';

                        commit('storeUserData', _.defaults(userData, state));

                        resolve(response);
                    })
                    .catch((error) => reject(error));

            });

        }
		
		
	
	} // END: actions


}


// WEBPACK FOOTER //
// ./src/restricted/Auth.js